import AppsIcon from '@mui/icons-material/Apps';
import { Collapse, Stack, Table, TableContainer, Typography } from '@mui/material'
import { ExpandMoreButton } from 'components/common/ExpandMoreButton';
import TableHeader               from 'components/table/TableHeader'
import TableRows                 from 'components/table/TableRows'
import RenderContextProvider     from 'contexts/RenderContext'
import React from 'react'
import { Section } from 'types/view';

type LoadingTableProps = {
  columns: any[],
  filterable?: boolean,
  rows: any,
  loading: boolean,
  containerSx: any,
  tableSx: any,
  section?: Section
  rowAction?: (row: any) => React.ReactNode
}

// TODO re-support scroll-to-top, which requires a forwardRef (see commented-out section below)
const LoadingTable = (props: LoadingTableProps) => {
  const {containerSx, section} = props
  const isGroup = section?.type === 'group'

  return <RenderContextProvider parent="table">
    <TableContainer
      className='large-table-container'
      sx={{
        height: "fit-content",
        maxHeight: "100%",
        maxWidth: '100%',
        ...containerSx,
      }}
    >
      {isGroup ? <CollapsibleTable {...props}/> : <NormalTable {...props}/>}
    </TableContainer>
  </RenderContextProvider>
}

const NormalTable = ({columns, filterable = false, rows, loading, tableSx, section, rowAction}: LoadingTableProps) => {
  return <Table
    id="loading-table"
    size="small" stickyHeader
    sx={{
      width: section?.width || '800px',
      overflow:"auto",
      minWidth: "0px",
      maxHeight: "100%",
      maxWidth: "100%",
      ...tableSx,
    }}
  >
    <TableHeader columns={columns} filterable={filterable}/>
    <TableRows columns={columns} rows={rows} section={section} loading={loading} rowAction={rowAction}/>
  </Table>
}

const CollapsibleTable = ({columns, rows, loading, tableSx, section, rowAction}: LoadingTableProps) => {
  const [expanded, setExpanded] = React.useState(true);
  const title = columns[0] || ''

  return <Stack>
    <Stack alignItems='center' justifyContent="space-between" direction='row' bgcolor='#f5f5f5' borderBottom='1px solid rgba(224, 224, 224, 1)' >
      <Stack alignItems='center' direction='row' spacing={1} marginLeft={1}>
        <AppsIcon color='disabled'/>
        <Typography marginLeft='16px' fontWeight={500} {...title.cellProps}>{title.headerName}</Typography>
      </Stack>
      <ExpandMoreButton expanded={expanded} setExpanded={setExpanded}/>
    </Stack>
    <Collapse in={expanded}>
      <Table
        id="loading-table"
        size="small" stickyHeader
        sx={{
          width: section?.width || '800px',
          overflow:"auto",
          minWidth: "0px",
          maxHeight: "100%",
          maxWidth: "100%",
          ...tableSx,
        }}
      >
        <TableRows columns={columns} rows={rows} section={section} loading={loading} rowAction={rowAction}/>
      </Table>
    </Collapse>
  </Stack>
}

/*
const LoadingTable = forwardRef<any>(({columns, rows, loading, containerSx, tableSx}: LoadingTableProps, ref) => (
  <RenderContextProvider parent="table">
    <TableContainer
      ref={ref}
      className='large-table-container'
      sx={{
        height: "fit-content",
        maxHeight: "100%",
        maxWidth: '100%',
        ...containerSx,
      }}
    >
      <Table
        id="loading-table"
        size="small" stickyHeader
        sx={{
          width: '800px',
          overflow:"auto",
          minWidth: "0px",
          maxHeight: "100%",
          maxWidth: "100%",
          ...tableSx,
        }}
      >
        <TableHeader columns={columns}/>
        <TableRows columns={columns} rows={rows} loading={loading}/>
      </Table>
    </TableContainer>
  </RenderContextProvider>
))
*/
export default LoadingTable
